import {Injectable} from '@angular/core';
import {AbstractControl, FormControl, ValidationErrors, ValidatorFn} from '@angular/forms';
import {GlobalVariable} from '../global';
import {FieldRequestParameters, RequestParameters} from '../shared/models/request-parameters/parameter.model';
import {Observable} from 'rxjs/Observable';
import {HttpClient} from '@angular/common/http';
@Injectable()
export class ProfileValidator {

  constructor(private http: HttpClient) {}

  uniqueUsernmeValidator(control: FormControl): Promise<any> | Observable<any> {
    return this.http.get(GlobalVariable.BASE_API_URL + '/profile/username/' + control.value)
      .map(
        (response: any) => {
          console.log(response);
        }
      );
  }
  uniqueEmailValidator(control: FormControl): Promise<any> | Observable<any> {

    const parameters: RequestParameters = new RequestParameters();
    parameters.fields.push(new FieldRequestParameters('email', control.value));
    return this.http.get(GlobalVariable.BASE_API_URL + '/profile', {
      params: parameters.getHttpParams(),
    })
      .map(
        (response: any) => {
          console.log(response);
        }
      );
  }
  uniquePhoneValidator(control: FormControl): Promise<any> | Observable<any> {

    const parameters: RequestParameters = new RequestParameters();
    parameters.fields.push(new FieldRequestParameters('phone', control.value));
    return this.http.get(GlobalVariable.BASE_API_URL + '/profile', {
      params: parameters.getHttpParams(),
    })
      .map(
        (response: any) => {
          console.log(response);
        }
      );
  }

  samePasswordValidator(control: FormControl, fisrtPassword: string) {
    if (control.value !== fisrtPassword) {
      return {
        notSamePassword: true
      };
    } else {
      return {
        notSamePassword: false
      };
    }
  }

  timezoneOffsetValidator(control: FormControl) {
    let value = + control.value;
      if(value < -12 || value > 14){
        return {
          timezoneOffsetError: true
        };
      }
  }

  confirmPassword(field: AbstractControl): { passwordMismatch: boolean } {
    const fieldParent = field.parent;
    const fieldValue = field.value;
    if (fieldParent !== null && fieldParent !== undefined) {
      const formValue = fieldParent.value;
      if (formValue.plainPasswordFirst !== fieldValue) {
        return {'passwordMismatch': true};
      } else {
        return;
      }
    }
  }

  static differentFromField(oldFieldName: string): ValidatorFn {
    return (control: AbstractControl): ValidationErrors | null => {
      const parent = control.parent;
      if (parent === null || parent === undefined) {
        return null;
      }
      const oldControl = parent.get(oldFieldName);
      if (oldControl === null) {
        return null;
      }
      const oldValue = oldControl.value;
      const newValue = control.value;
      if (oldValue === null || oldValue === undefined || oldValue === '' ||
          newValue === null || newValue === undefined || newValue === '') {
        return null;
      }
      if (String(oldValue) === String(newValue)) {
        return {sameAsOldPassword: true};
      }
      return null;
    };
  }

  static confirmMatchesField(matchFieldName: string): ValidatorFn {
    return (control: AbstractControl): ValidationErrors | null => {
      const parent = control.parent;
      if (parent === null || parent === undefined) {
        return null;
      }
      const matchControl = parent.get(matchFieldName);
      if (matchControl === null) {
        return null;
      }
      if (control.value !== matchControl.value) {
        return {passwordMismatch: true};
      }
      return null;
    };
  }

}



// WEBPACK FOOTER //
// C:/Users/DENISE/Documents/IT4U/web-callcenter/src/app/profile/profile.validators.ts